import type { FC } from "react";

interface SunsetBannerTitleProps {
  scope: string;
}
export const SunsetBannerTitle: FC<SunsetBannerTitleProps> = ({ scope }) => (
  <span>This store is sunset for the {scope} scope</span>
);

export const SunsetBannerBody: FC = () => (
  <>
    No new disputes or cases should be created and no new work packets will be identified. Existing work packets will
    continue to be monitored and updated by the Recovery Specialist or our system.
  </>
);
